<template>
	<v-container class="pa-0">
		<!-- Dialog Vademecuns Pessoais dos Membros do Grupo -->
		<v-dialog v-model="showVademecunsDialog" max-width="1200px" scrollable>
		<v-card>
			<v-card-title class="d-flex align-center" :style="{ color: dynamicColor }">
				<v-icon :color="dynamicColor" class="mr-2">mdi-account-multiple</v-icon>
				Vademecuns Pessoais dos Membros
				<v-spacer></v-spacer>
				<v-btn @click="showVademecunsDialog = false" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text style="max-height: 600px;" class="pa-4">
				<!-- Loading -->
				<div v-if="loadingVademecuns" class="text-center py-8">
					<v-progress-circular :color="dynamicColor" indeterminate size="64"></v-progress-circular>
					<p class="mt-4 grey--text">Carregando vademecuns...</p>
				</div>

				<!-- Empty State -->
				<div v-else-if="vademecuns.length === 0" class="text-center py-8">
					<v-icon size="80" color="grey lighten-2">mdi-book-open-variant</v-icon>
					<h3 class="mt-4 mb-2 grey--text">Nenhum vademecum pessoal compartilhado</h3>
					<p class="grey--text">Os membros do grupo ainda não compartilharam vademecuns pessoais públicos.</p>
					</div>

					<!-- Grid de Vademecuns -->
					<v-row v-else>
						<v-col v-for="(v, index) in vademecuns" :key="v.id" cols="12" md="6">
							<v-card outlined hover @click="verVademecum(v)" style="cursor: pointer;">
								<v-card-title class="d-flex justify-space-between align-center pa-3">
									<span class="text-subtitle-1 font-weight-bold" style="word-break:break-word;">
										{{ v.titulo || `Vade-mécum ${index + 1}` }}
										<v-icon :color="v.cor || dynamicColor" size="16">mdi-circle</v-icon>
									</span>
								</v-card-title>

								<v-card-text class="pa-3">
									<div class="mb-2">
										<v-chip v-if="v.leis && v.leis.length > 0" x-small :color="dynamicColor" text-color="white" class="mr-1">
											{{ v.leis.length }} {{ v.leis.length === 1 ? 'Lei' : 'Leis' }}
										</v-chip>
										<v-chip v-if="v.projetos_leis && v.projetos_leis.length > 0" x-small outlined :color="dynamicColor" class="mr-1">
											{{ v.projetos_leis.length }} Projetos
										</v-chip>
									</div>

									<!-- Autor -->
									<div class="d-flex align-center mt-2">
										<v-avatar size="24" class="mr-2">
											<v-img v-if="v.user_created && v.user_created.avatar" :src="`https://api.mylegis.com.br/assets/${v.user_created.avatar}`" />
											<v-icon v-else small>mdi-account-circle</v-icon>
										</v-avatar>
										<span class="text-caption grey--text">
											{{ v.user_created ? `${v.user_created.first_name} ${v.user_created.last_name || ''}` : 'Usuário' }}
										</span>
									</div>
								</v-card-text>

								<v-card-actions class="pa-2 d-flex justify-end">
									<v-btn x-small text :color="dynamicColor" @click.stop="verVademecum(v)">
										<v-icon small>mdi-eye</v-icon> Ver
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Dialog Ver Vademecum Detalhado -->
		<v-dialog v-model="showVademecumDetalhes" fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card v-if="vademecumSelecionado">
				<v-toolbar dark color="grey darken-3" class="elevation-0">
					<v-toolbar-title class="text-h6 font-weight-bold">
						<v-icon :color="vademecumSelecionado.cor || dynamicColor" size="20">mdi-circle</v-icon>
						{{ vademecumSelecionado.titulo || 'Vade-mécum' }}
					</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-chip class="mr-4" small>
						<v-icon small class="mr-1">mdi-account</v-icon>
						{{ vademecumSelecionado.user_created ? `${vademecumSelecionado.user_created.first_name}` : 'Usuário' }}
					</v-chip>
					<v-btn icon @click="showVademecumDetalhes = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<v-card-text class="pa-6" style="background-color: white;">
					<!-- Leis -->
					<div class="mb-6">
						<h3 class="text-h5 font-weight-bold mb-4" style="color: #424242;">
							Leis ({{ vademecumSelecionado.leis ? vademecumSelecionado.leis.length : 0 }})
						</h3>

						<div v-if="!vademecumSelecionado.leis || vademecumSelecionado.leis.length === 0" class="text-center pa-4" style="border: 2px dashed #e0e0e0; border-radius: 8px;">
							<p class="mb-0 grey--text">Este vade-mécum ainda não possui legislações.</p>
						</div>

						<v-card v-else v-for="lei in vademecumSelecionado.leis" :key="lei.id" outlined class="mb-3" style="border-radius: 8px;">
							<v-card-text class="pa-4">
								<div class="d-flex justify-space-between align-start">
									<div class="flex-grow-1">
										<h4 class="text-h6 font-weight-bold mb-2" style="color: #424242;">
											{{ lei.leis_id_lei.numero_lei }}
										</h4>
										<p class="text-body-1 mb-3" style="color: #666;">
											{{ lei.leis_id_lei.nome_lei }}
										</p>
									</div>
									<div>
										<v-chip small :color="dynamicColor" outlined>
											{{ lei.leis_id_lei.esfera_lei }}
										</v-chip>
									</div>
								</div>
							</v-card-text>
							<v-card-actions class="d-flex justify-end p-2">
								<v-btn small text :color="dynamicColor" :to="`/painel/lei/${lei.leis_id_lei.id_lei}/${sanitizeTitle(lei.leis_id_lei.numero_lei)}`">
									<v-icon small>mdi-file-document</v-icon> Ver Lei
								</v-btn>
							</v-card-actions>
						</v-card>
					</div>

					<!-- Projetos de Lei -->
					<div v-if="vademecumSelecionado.projetos_leis && vademecumSelecionado.projetos_leis.length > 0" class="mb-6">
						<h3 class="text-h5 font-weight-bold mb-4" style="color: #424242;">
							Projetos de Lei ({{ vademecumSelecionado.projetos_leis.length }})
						</h3>
						<v-card v-for="projeto in vademecumSelecionado.projetos_leis" :key="projeto.id" outlined class="mb-3" style="border-radius: 8px;">
							<v-card-text class="pa-4">
								<v-btn
									style="background-color: transparent; box-shadow: none; padding: 0; white-space: normal; display: block; text-align: left; justify-content: start;"
									:to="`/painel/projeto_lei/${projeto.projetos_leis_id.id}/${sanitizeTitle(projeto.projetos_leis_id.numero)}/${sanitizeTitle(vademecumSelecionado.titulo)}`"
								>
									<h4 class="text-h6 font-weight-bold mb-2" style="color: #424242;">
										{{ projeto.projetos_leis_id.numero }}
									</h4>
								</v-btn>
								<p class="text-body-1" style="color: #666;">
									{{ projeto.projetos_leis_id.nome }}
								</p>
							</v-card-text>
						</v-card>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-row class="mt-3">
			<!-- Sidebar com Card de Membros -->
			<v-col cols="12" lg="3" order="1" order-lg="2">
				<GroupMembersCard 
					:grupo="grupo"
					:integrantes="integrantes"
					@reload="reloadGrupo"
				/>
			</v-col>
			
			<!-- Área Principal -->
			<v-col cols="12" lg="9" order="2" order-lg="1">
				<!-- Header do Grupo -->
				<GroupHeader 
					:grupo="grupo"
					@reload="reloadGrupo"
				/>
				
				<!-- Conteúdo do Feed -->
				<div class="feed-content mt-4">
					<div class="d-flex justify-space-between align-center mb-4">
						<h2 :style="{ color: dynamicColor }">Feed do Grupo</h2>
						<v-btn 
							v-if="isAdmin" 
							color="#F15A24" 
							dark 
							@click="showNewAnnotation = true"
						>
							<v-icon left style="color: white !important;">mdi-plus</v-icon>
							NOVA ANOTAÇÃO
						</v-btn>
					</div>
					
					<div 
						v-if="anotacoes.length == 0 && anotacoesProjetos.length == 0 && !loadingFeed"
						class="mt-5"
					>
						<p>
							Ainda não existe conteúdo por aqui. Faça anotações e conexões para
							alimentar o seu feed.
						</p>
					</div>
					
					<div v-if="loadingFeed" class="text-center">
						<v-progress-circular 
							class="mx-auto" 
							:color="dynamicColor"
							indeterminate
						></v-progress-circular>
					</div>
					
					<div v-if="!loadingFeed">
						<div v-for="(annotation, i) in anotacoes" :key="i" class="mb-4">
							<annotation
								:annotation="annotation"
								:restrict-to-group-import="!isAdmin"
								:current-group-id="$route.params.id_grupo"
								@annotation-deleted="onAnnotationDeleted"
							></annotation>
						</div>

						<div v-for="(annotation, i) in anotacoesProjetos" :key="i" class="mb-4">
							<AnnotationProjetolei
								:annotation="annotation"
								:restrict-to-group-import="!isAdmin"
								:current-group-id="$route.params.id_grupo"
								@annotation-deleted="onAnnotationProjetoDeleted"
							></AnnotationProjetolei>
						</div>
					</div>
				</div>
			</v-col>
		</v-row>
		<v-dialog width="800px" v-model="showNewAnnotation">
			<v-card class="px-5">
				<v-card-title  v-if="isAdmin" class="px-0">Nova Anotação <v-spacer />
					<v-btn @click="showNewAnnotation = false" text><v-icon large>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-card-text>
					<h3>Conteúdo</h3>
					<div class="d-flex">
						<v-spacer></v-spacer>
						<v-btn text small @click="undo"><v-icon>mdi-undo</v-icon> Desfazer</v-btn>
						<v-btn @click="redo" text small><v-icon>mdi-redo</v-icon> Refazer</v-btn>
						<v-file-input v-model="files" style="height:20px; margin-top:-20px;"
							placeholder="Adicionar Arquivo" flat :prepend-icon="'mdi-plus'" @change="newFile"
							color="#F15A24">
						</v-file-input>
					</div>
					<VueEditor use-custom-image-handler @image-added="handleImageAdded" ref="editor" color="#F15A24"
						:editor-toolbar="customToolbar" v-model="annotation.texto" />
				</v-card-text>
				<v-card-actions class="justify-end px-0">
					<v-btn text @click="showNewAnnotation = false">Cancelar</v-btn>
					<v-btn :loading="loadingNewAnnotation" dark @click="saveNewAnnotation()" color="#F15A24">Salvar
						<v-icon class="ml-1" small>mdi-content-save</v-icon>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Dialog Aceitar Liderança -->
		<DialogAceitarLideranca 
			v-model="showDialogAceitarLideranca"
			:convite="conviteLiderancaPendente"
		/>
	</v-container>
</template>

<style scoped>
a {
	text-decoration: none;
	color: black !important;
}

a:hover {
	color: #f15a24;
}

h2 {
	font-family: 'Inter';
	font-weight: bold;
	color: #707070;
	text-align: left;
}

.filesButton {
	text-decoration: none !important;
}

.annotation {
	border: 1px solid rgb(200 200 200) !important;
	margin: 8px 0px;
	border-radius: 10px;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
	max-width: 100% !important;
}

.annotation ::v-deep iframe {
	height: 250px;
}

.annotationText div {
	width: 100%;
}

.reg {
	border: 1px dashed gray;
	border-radius: 10px;
	padding: 5px;
}

/* Estilos para o grupo específico */
:deep(.v-tabs__bar) {
	background-color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-tabs__item--active) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-tabs__item:hover) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-btn--icon) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-icon) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

/* Exceção: não aplicar cor aos ícones dentro dos chips de anexos */
:deep(.annotation .v-chip .v-icon),
:deep(.annotation .v-chip__close),
:deep(.annotation .v-chip__close i),
:deep(.annotation .v-chip[color="#F15A24"] .v-icon),
:deep(.annotation .v-chip[color="#F15A24"] .v-chip__close),
:deep(.annotation .v-chip[color="#F15A24"] .v-chip__close i) {
	color: white !important;
}

:deep(.v-btn--text) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}

:deep(.v-btn--text:hover) {
	color: v-bind('$route.params.id_grupo === "6f5ff131-006f-4525-9b17-75ae9674a09f" ? "#d8934e" : "#F15A24"') !important;
}
</style>

<script>
import GroupHeader from '../components/GroupHeader.vue';
import GroupMembersCard from '../components/GroupMembersCard.vue';
import DialogAceitarLideranca from '../components/DialogAceitarLideranca.vue';
import Annotation from '../components/Annotation.vue';
import AnnotationProjetolei from '../components/AnnotationProjetolei.vue';
import { VueEditor } from 'vue2-editor';

export default {
	components: { 
		GroupHeader, 
		GroupMembersCard, 
		Annotation, 
		DialogAceitarLideranca, 
		VueEditor, 
		AnnotationProjetolei 
	},
	data: () => ({
		showNewAnnotation: false,
		showDialogAceitarLideranca: false,
		conviteLiderancaPendente: null,
		active: "feed",
		grupo: { administradores: [] },
		anotacoes: [],
		anotacoesProjetos: [],
		loadingFeed: false,
		integrantes: [],
		showVademecunsDialog: false,
		loadingVademecuns: false,
		vademecuns: [],
		showVademecumDetalhes: false,
		vademecumSelecionado: null,
		loadingNewAnnotation: false,
		annotation: {
			texto: '',
			id_grupo: null
		},
		files: null,
		statusAnnotation: [
			{ text: 'Público', value: 'published' },
			{ text: 'Grupo', value: 'group' },
			{ text: 'Privado', value: 'private' },
			{ text: 'Apenas Amigos', value: 'friend' },
			{ text: 'Arquivado', value: 'archived' },
		],
		customToolbar: [
			[{ font: [] }, { size: [] }],
			['bold', 'italic', 'underline', 'strike'],
			[{ color: [] }, { background: [] }],
			// [{ script: "super" }, { script: "sub" }],
			[{ header: '1' }, { header: '2' }, 'blockquote', 'code-block'],

			[
				{ list: 'ordered' },
				{ list: 'bullet' },
				{ indent: '-1' },
				{ indent: '+1' },
			],
			['direction', { align: [] }],
			['link', 'image', 'video'],
			['clean'],
		],
	}),
	mounted() {
		this.reloadGrupo();
		// Verificar convites de liderança pendentes se for grupo Eleitores e o usuário é o proprietário
		if (this.isEleitoresGroup && this.isOwner) {
			this.verificarConvitesLideranca();
		}
	},
	computed: {
		groups() {
			return this.$store.state.filteredGroups;
		},
		isAdmin() {
			// return false
			return this.grupo.administradores.find(
				(e) => e.directus_users_id.id === this.$store.state.user.id
			);
		},
		isOwner() {
			return this.grupo.user_created === this.$store.state.user.id;
		},
		user() {
			return this.$store.state.user;
		},
		dynamicColor() {
			return this.$route.params.id_grupo === '6f5ff131-006f-4525-9b17-75ae9674a09f' ? '#d8934e !important' : '#F15A24';
		},
		isGabineteGroup() {
			if (!this.grupo) return false;
			// Verifica se o tipo_grupo é 'gabinete' ou se o nome contém "Gabinete"
			return this.grupo.tipo_grupo === 'gabinete' || (this.grupo.nome_grupo && this.grupo.nome_grupo.includes('Gabinete'));
		},
		isEleitoresGroup() {
			if (!this.grupo) return false;
			// Grupo de eleitores identificado por tipo_grupo ou pelo nome
			return this.grupo.tipo_grupo === 'eleitores' ||
				(this.grupo.nome_grupo && this.grupo.nome_grupo.includes('Eleitores'));
		}
	},
	methods: {
		isInAdmin(id) {
			let eh = this.grupo.administradores.find(
				(e) => e.directus_users_id.id === id
			);
			return eh !== undefined;
		},
		async verificarConvitesLideranca() {
			try {
				// Buscar todos os convites pendentes para este usuário
				// Buscar também o campo id_grupo direto (sem aninhamento) como fallback
				const { data } = await this.$http.get(
					`items/add_grupos?filter[status][_eq]=pendente&filter[id_usuario][_eq]=${this.$store.state.user.id}&fields=id,id_grupo,id_grupo.id,id_grupo.nome_grupo,id_grupo.tipo_grupo`
				);

				if (data.data && data.data.length > 0) {
					// Filtrar apenas convites de grupos Eleitores (lideranças)
					const convitesLideranca = data.data.filter(convite => {
						const grupo = convite.id_grupo;
						if (!grupo) return false;
						
						// Verificar se é grupo Eleitores
						return grupo.tipo_grupo === 'eleitores' || (grupo.nome_grupo && grupo.nome_grupo.includes('Eleitores'));
					});

					if (convitesLideranca.length > 0) {
						// Pegar o primeiro convite de liderança pendente
						const convite = convitesLideranca[0];
						
						// Extrair ID do grupo corretamente
						// Tentar primeiro id_grupo.id (relacionamento aninhado)
						// Se não existir, tentar id_grupo direto (pode ser ID string/number)
						let grupoId = null;
						
						if (convite.id_grupo) {
							if (typeof convite.id_grupo === 'object' && convite.id_grupo !== null) {
								// Se for objeto, pegar o ID do objeto aninhado
								grupoId = convite.id_grupo.id;
							} else if (typeof convite.id_grupo === 'string' || typeof convite.id_grupo === 'number') {
								// Se for string ou número direto (ID do relacionamento)
								grupoId = convite.id_grupo;
							}
						}
						
						// Validar e converter para string
						if (grupoId && grupoId !== 'undefined' && grupoId !== undefined && grupoId !== null) {
							this.conviteLiderancaPendente = {
								id: convite.id,
								id_grupo: String(grupoId), // Garantir que é string
							};
							this.showDialogAceitarLideranca = true;
						}
					}
				}
			} catch (error) {
				// Erro ao verificar convites
			}
		},
		reloadGrupo() {
			this.$http
				.get(
					'items/grupos/' +
					this.$route.params.id_grupo +
					'?fields=integrantes.*,administradores.*,administradores.directus_users_id.*,integrantes.directus_users_id.*,lideranca.*,*'
				)
				.then((res) => {
					this.grupo = res.data.data;
					if (this.grupo.adminsitradores) {
						this.integrantes = this.grupo.integrantes.filter(
							(el) =>
								!this.grupo.administradores.find(
									(e) => e.directus_users_id.id === el.directus_users_id.id
								)
						);
					} else this.integrantes = this.grupo.integrantes;
					this.loadGroupsFeed();
					this.loadGroupsFeedProjetoLei();
					
					// Verificar convites de liderança após carregar o grupo
					if (this.isEleitoresGroup && this.isOwner) {
						this.verificarConvitesLideranca();
					}
				});
		},		async loadVademecuns() {
			try {
				this.loadingVademecuns = true;
				const grupoId = this.$route.params.id_grupo;
				
				// Buscar vademecuns públicos dos membros do grupo (PESSOAIS, sem id_grupo)
				const { data } = await this.$http.get(
					`items/vademecums?fields=*,leis.id,leis.leis_id_lei.*,projetos_leis.*,projetos_leis.projetos_leis_id.*,user_created.id,user_created.first_name,user_created.last_name,user_created.avatar&filter[status][_eq]=public&filter[id_grupo][_null]=true&sort=-date_created`
				);

				// Buscar integrantes do grupo
				const grupoRes = await this.$http.get(
					`items/grupos/${grupoId}?fields=integrantes.directus_users_id.id`
				);
				
				const integrantesIds = grupoRes.data.data.integrantes.map(i => i.directus_users_id.id);
				
				// Filtrar apenas vademecuns PESSOAIS (sem id_grupo) dos integrantes do grupo
				this.vademecuns = data.data.filter(v => {
					const userId = v.user_created && v.user_created.id ? v.user_created.id : v.user_created;
					// Garante que não tenha id_grupo (vademecum pessoal)
					return integrantesIds.includes(userId) && !v.id_grupo;
				});

			} catch (error) {
				window.console.error('Erro ao carregar vademecuns do grupo:', error);
			} finally {
				this.loadingVademecuns = false;
			}
		},
		verVademecum(vademecum) {
			this.vademecumSelecionado = vademecum;
			this.showVademecumDetalhes = true;
		},
		// sanitizeTitle(title) {
		// 	if (!title) return '';
		// 	let slug = title.toString().toLowerCase().trim();
		// 	slug = slug.replace(/\s+/g, '-');
		// 	return encodeURIComponent(slug);
		// },		
		async loadGroupsFeed() {
			this.loadingFeed = true;
			this.anotacoes = [];
			
			// Verificar se o grupo tem liderança configurada
			const grupoLiderancaId = this.grupo.lideranca && this.grupo.lideranca.id 
				? this.grupo.lideranca.id 
				: null;
			
			// Construir o filtro: se tiver liderança, buscar posts do grupo atual E do grupo de liderança
			let filterCondition = '';
			if (grupoLiderancaId) {
				// Se tiver liderança, usar _or para buscar de ambos os grupos
				filterCondition = `_or: [
					{ id_grupo: { id: { _eq: "${this.grupo.id}" }}},
					{ id_grupo: { id: { _eq: "${grupoLiderancaId}" }}}
				]`;
			} else {
				// Caso contrário, buscar apenas do grupo atual
				filterCondition = `id_grupo: { id: { _eq: "${this.grupo.id}" }}`;
			}
			
			const query = `query MyGroup {
			anotacoes(
				filter: {  
					_and: [
						{ ${filterCondition} },
						{ status: { _neq: "archived" } }
					]
				}
			) {
				id
				texto
				date_created
				likes { 
					id 
					first_name
				}
				comentarios(filter: { status: { _eq: "published" } }) {
					id
					message
					user_created {
						id
						first_name
						avatar {
							id
						}
					}
					files {
						id
						directus_files_id {
							id
							filename_download
						}
					}
				}
				date_updated
				status
				user_created {
					first_name
					last_name
					id
					avatar { 
						id 
					}
				}
				id_lei {
					id_lei
					numero_lei
				}
				id_reg { 
					id_reg
					conteudo
				}
				id_grupo { 
					id
					nome_grupo
				}  
			}
				}`;
			const {
				data: { data },
			} = await this.$http.post('/graphql', {
				query,
			});
			// Substituir a lista ao invés de concatenar para garantir atualização completa
			this.anotacoes = (data.anotacoes || []).sort(
				(a, b) => new Date(b.date_created) - new Date(a.date_created)
			);
			this.loadingFeed = false;
		},
		async loadGroupsFeedProjetoLei() {
			this.anotacoesProjetos = [];
			try {
				// Verificar se o grupo tem liderança configurada
				const grupoLiderancaId = this.grupo.lideranca && this.grupo.lideranca.id 
					? this.grupo.lideranca.id 
					: null;
				
				// Construir o filtro: se tiver liderança, buscar posts do grupo atual E do grupo de liderança
				let filterCondition = '';
				if (grupoLiderancaId) {
					// Se tiver liderança, usar _or para buscar de ambos os grupos
					filterCondition = `_or: [
						{ grupo: { id: { _eq: "${this.grupo.id}" }}},
						{ grupo: { id: { _eq: "${grupoLiderancaId}" }}}
					]`;
				} else {
					// Caso contrário, buscar apenas do grupo atual
					filterCondition = `grupo: { id: { _eq: "${this.grupo.id}" }}`;
				}
				
				const query = `query MyGroup {
				projetos_leis_anotacoes(
					filter: {  
						_and: [
							{ ${filterCondition} },
							{ status: { _neq: "archived" } }
						]
					}
				) {
					id
					texto
					date_created
					likes { 
						id 
					}
					comentarios(filter: { status: { _eq: "published" } }) {
						id
						message
						user_created { 
							id
							first_name
							avatar { 
								id 
							}
						}
						files {
							id
							directus_files_id {
								id
								filename_download
							}
						}
					}
					date_updated
					status
					user_created {
						first_name
						last_name
						id
						avatar { 
							id 
						}
					}
					projeto_lei {
						numero
					}
				
					grupo { 
						id
						nome_grupo
					}  
		
				}
					}`;
				const {
					data: { data },
				} = await this.$http.post('/graphql', {
					query,
				});
				
				if (data && data.projetos_leis_anotacoes) {
					// Substituir a lista ao invés de concatenar para garantir atualização completa
					this.anotacoesProjetos = (data.projetos_leis_anotacoes || []).sort(
						(a, b) => new Date(b.date_created) - new Date(a.date_created)
					);
				}
				this.loadingFeed = false;
			} catch (error) {
				window.console.error('Erro ao carregar anotações de projetos de lei:', error);
				this.loadingFeed = false;
			}
		},
		handleImageAdded(file, Editor, cursorLocation) {
			const formData = new FormData();
			formData.append('image', file);
			this.$http
				.post('/files', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then((response) => {
					let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
					Editor.insertEmbed(cursorLocation, 'image', url);
				})
				.catch((err) => {
					window.console.error('Erro ao fazer upload da imagem:', err);
				});
		},
		async saveNewAnnotation() {
			this.loadingNewAnnotation = true;
			try {
				const response = await this.$http.post('items/anotacoes', {
					texto: this.annotation.texto,
					status: 'group',
					id_grupo: { id: this.grupo.id }
				});

				if (response.data.data.id) {
					this.showNewAnnotation = false;
					this.annotation.texto = '';
				this.loadGroupsFeed();
				this.loadGroupsFeedProjetoLei();
			}
		} catch (error) {
			window.console.error('Erro ao salvar anotação:', error);
		} finally {
			this.loadingNewAnnotation = false;
		}
	},
	async onAnnotationDeleted(annotationId) {
		// Recarregar o feed completo, seguindo exatamente o mesmo padrão usado ao adicionar anotação
		this.loadGroupsFeed();
		this.loadGroupsFeedProjetoLei();
	},
	async onAnnotationProjetoDeleted(annotationId) {
		// Recarregar o feed completo, seguindo exatamente o mesmo padrão usado ao adicionar anotação
		this.loadGroupsFeed();
		this.loadGroupsFeedProjetoLei();
	},
		newFile(file) {
			if (!file) return;
			const formData = new FormData();
			formData.append('file', file);
			this.$http.post('/files', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(response => {
				const url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
				this.$refs.editor.quill.insertEmbed(this.$refs.editor.quill.getSelection().index, 'image', url);
			});
		},
		undo() {
			this.$refs.editor.quill.history.undo();
		},
		redo() {
			this.$refs.editor.quill.history.redo();
		},
		sanitizeTitle: function (title) {
			var slug = '';
			// Change to lower case
			var titleLower = title.toLowerCase();
			// Letter "e"
			slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
			// Letter "a"
			slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
			// Letter "o"
			slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
			// Letter "u"
			slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
			// Letter "d"
			slug = slug.replace(/đ/gi, 'd');
			// Trim the last whitespace
			slug = slug.replace(/\s*$/g, '');
			// Change whitespace to "-"
			slug = slug.replace(/\s+/g, '-');
			return slug;
		},
	},
};
</script>
